<div class="@container block">
  <li
    class="flex @5xl:items-center gap-4 py-4 px-6 border-outline dark:border-outline-darkmode"
    data-track="cockpit-energy-interface-card"
    [attr.data-energy-interface-id]="energyInterface().id"
  >
    <div
      class="flex flex-col @5xl:grid grid-cols-1 @5xl:grid-cols-4 gap-x-6 gap-y-2 @5xl:items-center justify-center flex-1 text-sm text-on-surface-subtle dark:text-on-surface-subtle-darkmode overflow-hidden text-ellipsis whitespace-nowrap"
    >
      <div class="grid grid-cols-2 @5xl:flex gap-2 items-center text-sm">
        <div class="overflow-hidden text-ellipsis whitespace-nowrap @5xl:hidden font-semibold">
          {{ 'cockpit.energyInterfaces.list.labelLabel' | transloco }}
        </div>
        <div class="hidden @5xl:block">
          <div
            class="flex-none p-2 rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)]"
            [ngClass]="
              {
                ELECTRICITY:
                  'bg-power-soft dark:bg-power-soft-darkmode text-on-power-soft dark:text-on-power-soft-darkmode',
                GAS: 'bg-gas-soft dark:bg-gas-soft-darkmode text-on-gas-soft dark:text-on-gas-soft-darkmode',
              }[energyInterface().data?.utilityType ?? 'GAS']
            "
          >
            @switch (energyInterface().data?.utilityType) {
              @case ('ELECTRICITY') {
                <ng-icon name="heroBolt" size="16" class="!block size-5" />
              }
              @case ('GAS') {
                <ng-icon name="heroFire" size="16" class="!block size-5" />
              }
            }
          </div>
        </div>
        <span class="overflow-hidden text-ellipsis whitespace-nowrap @5xl:font-semibold">{{
          energyInterface().data?.label
        }}</span>
      </div>
      <div class="grid grid-cols-2 @5xl:flex gap-1.5">
        <span class="overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-sm mr-1">{{
          'cockpit.energyInterfaces.list.maloLabel' | transloco
        }}</span>
        <span class="overflow-hidden text-ellipsis whitespace-nowrap">
          {{ energyInterface().data?.maloID || '-' }}
        </span>
      </div>
      <div class="grid grid-cols-2 @5xl:flex gap-1.5">
        <span
          class="flex-none overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-sm mr-1"
          >{{ 'cockpit.energyInterfaces.list.meterLabel' | transloco }}</span
        >
        <span class="overflow-hidden text-ellipsis whitespace-nowrap">
          {{ energyInterface().data?.meterID || '-' }}
        </span>
      </div>
      <div class="grid grid-cols-2 @5xl:flex gap-1.5">
        <span class="font-semibold text-sm mr-1">{{
          'cockpit.energyInterfaces.list.contractLabel' | transloco
        }}</span>
        @if (energyInterface().data?.activeSupplierContract) {
          <div
            class="hidden @5xl:flex px-2 py-1 rounded-full outline outline-1 outline-offset-[-1px] outline-outline flex justify-center items-center gap-1"
          >
            <div class="bg-secondary-soft-outline h-2 w-2 rounded-full"></div>
            <div class="justify-start text-xs font-medium leading-4">
              {{ energyInterface().data?.activeSupplierContract?.productName }}
            </div>
          </div>
          <div class="overflow-hidden text-ellipsis whitespace-nowrap @5xl:hidden">
            {{ energyInterface().data?.activeSupplierContract?.productName }}
          </div>
        } @else {
          -
        }
      </div>
    </div>
    <div>
      <a
        [routerLink]="[
          '/organizations',
          organizationId(),
          'energy-interfaces',
          energyInterface().id,
        ]"
      >
        <ui-button mode="outlined" size="small" class="hidden @5xl:inline flex-none">
          {{ 'cockpit.energyInterfaces.list.detailsButton' | transloco }}
          <ng-icon slot="end" name="heroArrowRight" size="20" class="!block" />
        </ui-button>
        <ui-button
          [iconOnly]="true"
          mode="outlined"
          size="small"
          class="@5xl:hidden flex-none"
          [ariaLabel]="'cockpit.energyInterfaces.list.detailsButton' | transloco"
        >
          <ng-icon name="heroArrowRight" size="20" class="!block" />
        </ui-button>
      </a>
    </div>
  </li>
</div>
